module.exports = __webpack_public_path__ + "built-card-bottom-left@2x.3T-X24MN.png";